import { generatePath } from "react-router-dom";

const FrontSiteBase = "/";

const FrontSiteRoutesList = {
  home: FrontSiteBase,
  patronProfile: `${FrontSiteBase}profile`,
  documentsList: `${FrontSiteBase}search`,
  documentDetails: `${FrontSiteBase}literature/:documentPid`,
  slipForm: `${FrontSiteBase}slip-form/:documentPid`,
  documentRequestForm: `${FrontSiteBase}request`,
  openingHours: `${FrontSiteBase}opening-hours`,
  seriesDetails: `${FrontSiteBase}series/:seriesPid`,
  errors: `${FrontSiteBase}error`,
  selfCheckout: `${FrontSiteBase}selfcheckout`,
  dashboard: `${FrontSiteBase}dashboard`,
  feedback: `${FrontSiteBase}feedback`,
  faqs: `${FrontSiteBase}FAQs`,
  specialCollectionDetails: `${FrontSiteBase}specialCollection/:specialCollectionPid`,
  attendance: `${FrontSiteBase}attendance`,
};

const FrontSiteRoutesGenerators = {
  documentsListWithQuery: (qs) =>
    `${FrontSiteRoutesList.documentsList}?q=${qs}`,
  documentDetailsFor: (documentPid) =>
    generatePath(FrontSiteRoutesList.documentDetails, {
      documentPid: documentPid,
    }),
  seriesDetailsFor: (seriesPid) =>
    generatePath(FrontSiteRoutesList.seriesDetails, {
      seriesPid: seriesPid,
    }),
  specialCollectionDetailsFor: (specialCollectionPid) =>
    generatePath(FrontSiteRoutesList.specialCollectionDetails, {
      specialCollectionPid: specialCollectionPid,
    }),
  slipFormFor: (documentPid) =>
    generatePath(FrontSiteRoutesList.slipForm, {
      documentPid: documentPid,
    }),
};

export const FrontSiteRoutes = {
  ...FrontSiteRoutesGenerators,
  ...FrontSiteRoutesList,
};
